import { useTranslation } from '@lyearn/i18n';
import { InfoOutline } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';
export const INFO_ICON_FILL = 'var(--icon-primary)' as const;
export default function LocalisedSttingInfo() {
  const { t } = useTranslation();
  return (
    <Stack
      alignItems="center"
      className="px-16 py-12 bg-bg-tertiary mt-12 w-full"
      direction="row"
      justifyContent="start">
      <InfoOutline fill={INFO_ICON_FILL} height={16} width={16} />
      <Typography className="ml-8" color="text-text-paragraph" variant="body-short-04">
        {t('Common:Form.LocalizedContentReadOnlyInfo')}
      </Typography>
    </Stack>
  );
}
